import * as React from 'react';
import { Icon } from '../../primitives/icon/icon';
/* tslint:disable */
export var articleIcon = "\n<svg width=\"11\" height=\"13\" viewBox=\"0 0 11 13\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><rect width=\"11\" height=\"13\" rx=\"2\"/><path fill=\"#C1E4FE\" d=\"M2 3h7v1H2zM2 6h5v1H2zM2 9h7v1H2z\"/></g></svg>\n";
export var ArticleIcon = function () { return React.createElement(Icon, { icon: articleIcon }); };
//# sourceMappingURL=article.js.map